// extracted by mini-css-extract-plugin
export default {"thumbs":"styles_thumbs__h6S2A","thumbs_slide":"styles_thumbs_slide__Yz-ci","live":"styles_live__XRoj4"};